import React, { Component } from "react";
import { Row, Col, Table, Input, Popconfirm, message, Button } from "antd";
import { DeleteOutlined, SaveOutlined } from "@ant-design/icons";
import { withRouter } from "react-router-dom";
import PlusIcon from "../../svg/svgicon/PlusIcon";
import ButtonLinkIcon from "../../Components/MyComponent/ButtonLinkIcon";
import { API } from "../../API/API";
class MemberTypeConfig extends Component {
  state = {
    data: [],
    showNewInputForm: false,
    selectedMemberTypeId: 0,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get("/getMemberTypeList").then((response) => {
      if (response.status === 200) {
        this.setState({
          data: response.data.retData,
        });
      }
    });
  };
  addRow = () => {
    let newRow = {
      membertypeid: -1 - this.state.data.length,
      membertypename: "",
    };
    this.setState({
      data: [newRow, ...this.state.data],
    });
  };
  onChangeName = (e, record) => {
    this.setState(
      this.state.data.map((item) => {
        item.membertypename =
          item.membertypeid === record.membertypeid
            ? e.target.value
            : item.membertypename;
      })
    );
  };
  handleDelete = (typeid) => {
    API.get("deleteMemberType?membertypeid=" + typeid).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        const dataSource = [...this.state.data];
        this.setState({
          data: dataSource.filter((item) => item.membertypeid !== typeid),
        });
      }
    });
  };
  save = () => {
    let body = [...this.state.data];
    API.post("saveMemberType", body).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        message.success("Амжилттай хадгаллаа.");
        this.getData();
      }
    });
  };
  render() {
    const columns = [
      {
        title: "Үнэлгээний хорооны төрөл",
        dataIndex: "membertypename",
        key: "membertypename",
        width: "50%",
        align: "left",
        render: (text, record) => {
          return (
            <Input
              style={{ minWidth: "100%" }}
              align="center"
              autoFocus="autoFocus"
              defaultValue={record.membertypename}
              onChange={(value) => this.onChangeName(value, record)}
            />
          );
        },
      },
      {
        title: " ",
        dataIndex: "operation",
        width: "1%",
        render: (_, record) =>
          this.state.data.length > 0 ? (
            <Popconfirm
              title="Уcтгахдаа итгэлтэй байна уу?"
              onConfirm={() => this.handleDelete(record.membertypeid)}
            >
              <Button
                type="link"
                icon={<DeleteOutlined style={{ color: "red" }} />}
              />
            </Popconfirm>
          ) : null,
      },
      {
        title: "",
        dataIndex: "",
        key: "",
        width: "40%",
        align: "left",
      },
    ];
    return (
      <div className="Container">
        <Row align="middle">
          <Col span={24}>
            <Row style={{ height: 56 }} justify="start" align="middle">
              <Col>
                <div className="HeaderLabel">Үнэлгээний хорооны төрөл</div>
              </Col>
              <Col>
                <div className="divider"></div>
              </Col>
              <Col>
                <ButtonLinkIcon
                  onClick={() => this.addRow()}
                  icon={<PlusIcon />}
                  name="Мөр нэмэх"
                />
              </Col>
              <Col>
                <ButtonLinkIcon
                  onClick={() => this.save()}
                  icon={<SaveOutlined style={{ color: "#0358A7" }} />}
                  name="Хадгалах"
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <div id="tender-list" style={{ marginRight: 15 }}>
          <Table
            dataSource={this.state.data}
            columns={[
              {
                title: "№",
                dataIndex: "key",
                key: "key",
                width: "3%",
                render: (text, row, index) => (
                  <>{this.state.data.indexOf(row) + 1}</>
                ),
              },
              ...columns,
            ]}
            pagination={true}
            rowKey="membertypeid"
          />
        </div>
      </div>
    );
  }
}

export default withRouter(MemberTypeConfig);
